/* ==========================================================================
   ALBEUX BRAND REVEAL SCRIPT (assets/albeux-brand-reveal.js)
   Pairs with albeux-brand-reveal.css. Read the comment at the top of that file first.

   What it does, in order:
   1. Looks at the logo picture once (a hidden copy drawn on a canvas) and finds the empty gaps between the six letters.
   2. Builds six pieces on top of the logo: A, L, B, E, U, X.
   3. A appears in the centre of the logo (quick, soft fade, no waiting).
   4. The very same instant, L, B, E, U, X slide out from behind the A to their places on the right, one after another, each melting from a little blur into focus,
      while the A glides left to its place. One long, soft easing (it starts fast and settles slowly) so it feels expensive, not bouncy.
   5. The real logo is shown again and the pieces are removed.

   Numbers you can change (milliseconds):
   HOLD     how long the A is alone before the letters leave (0 = the letters leave the instant the A appears)
   MOVE     how long each letter takes to slide out
   STAGGER  the gap between one letter and the next
   ========================================================================== */
(function () {
  if (window.__albeuxBrandJs) return;
  window.__albeuxBrandJs = true;
  var doc = document.documentElement;
  if (!doc.classList.contains('alb-brand-pending')) return;

  var HOLD = 0;
  var MOVE = 1400;
  var STAGGER = 70;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  var finished = false;
  function done() {
    if (finished) return;
    finished = true;
    try { sessionStorage.setItem('albBrand', '1'); } catch (e) {}
    doc.classList.remove('alb-brand-pending');
    doc.classList.add('alb-brand-done');
    var nodes = document.querySelectorAll('.alb-brand-fx');
    for (var i = 0; i < nodes.length; i++) nodes[i].parentNode.removeChild(nodes[i]);
  }

  if (!Element.prototype.animate) { done(); return; }
  var img = document.querySelector('#header-component .header-logo__image');
  if (!img) { done(); return; }

  /* Find the six letters: columns of the picture that contain any visible pixel, separated by empty columns */
  function analyze(probe) {
    var nw = probe.naturalWidth;
    var nh = probe.naturalHeight;
    if (!nw || !nh) return null;
    var sw = Math.min(nw, 800);
    var sh = Math.max(1, Math.round(nh * sw / nw));
    var cv = document.createElement('canvas');
    cv.width = sw;
    cv.height = sh;
    var cx = cv.getContext('2d');
    cx.drawImage(probe, 0, 0, sw, sh);
    var data = cx.getImageData(0, 0, sw, sh).data;
    var ink = [];
    var x;
    var y;
    for (x = 0; x < sw; x++) {
      var on = false;
      for (y = 0; y < sh; y++) {
        if (data[(y * sw + x) * 4 + 3] > 40) { on = true; break; }
      }
      ink.push(on);
    }
    var runs = [];
    var start = -1;
    for (x = 0; x <= sw; x++) {
      if (x < sw && ink[x]) { if (start < 0) start = x; }
      else if (start >= 0) { runs.push({ l: start, r: x }); start = -1; }
    }
    /* Join pieces that are only a hair apart, drop specks */
    var merged = [];
    runs.forEach(function (r) {
      var last = merged[merged.length - 1];
      if (last && r.l - last.r < 2) last.r = r.r; else merged.push({ l: r.l, r: r.r });
    });
    merged = merged.filter(function (r) { return r.r - r.l >= 3; });
    if (!merged.length) return null;
    return merged.map(function (r) { return { l: r.l / sw, r: r.r / sw }; });
  }

  function pick(segs) {
    if (!segs) return [{ l: 0, r: 1 }];
    if (segs.length === 6) return segs;
    if (segs.length >= 2) return [segs[0], { l: segs[1].l, r: segs[segs.length - 1].r }];
    return [{ l: 0, r: 1 }];
  }

  function play(segs) {
    if (finished) return;
    var W = img.offsetWidth;
    var H = img.offsetHeight;
    if (!W || !H) { done(); return; }
    var parent = img.parentNode;
    if (window.getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    var box = document.createElement('span');
    box.className = 'alb-brand-fx';
    box.setAttribute('aria-hidden', 'true');
    box.style.left = img.offsetLeft + 'px';
    box.style.top = img.offsetTop + 'px';
    box.style.width = W + 'px';
    box.style.height = H + 'px';

    var src = img.currentSrc || img.src;
    var n = segs.length;
    var layers = [];
    var clones = [];
    var k;
    /* Letters are added first and the A last, so the A sits on top and the letters slide out from behind it */
    for (k = n - 1; k >= 0; k--) {
      var left = k === 0 ? 0 : (segs[k - 1].r + segs[k].l) / 2;
      var right = k === n - 1 ? 1 : (segs[k].r + segs[k + 1].l) / 2;
      var layer = document.createElement('span');
      layer.className = 'alb-brand-g';
      var c = document.createElement('img');
      c.alt = '';
      c.decoding = 'sync';
      c.src = src;
      c.style.clipPath = 'inset(0 ' + ((1 - right) * 100).toFixed(3) + '% 0 ' + (left * 100).toFixed(3) + '%)';
      layer.appendChild(c);
      box.appendChild(layer);
      layers[k] = layer;
      clones.push(c);
    }
    parent.appendChild(box);

    var ready = Promise.all(clones.map(function (c) { return c.decode ? c.decode().catch(function () {}) : Promise.resolve(); }));
    var wait = Promise.race([ready, new Promise(function (r) { setTimeout(r, 1500); })]);
    wait.then(function () {
      if (finished) return;
      /* The A shows at once (short soft fade, no delay) and the letters start leaving in the same moment */
      box.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, delay: 0, easing: 'ease-out', fill: 'both' });
      if (n === 1) { setTimeout(done, 900); return; }
      var center = function (s) { return ((s.l + s.r) / 2) * W; };
      var dA = W / 2 - center(segs[0]);
      layers[0].animate(
        [{ transform: 'translate3d(' + dA + 'px,0,0)' }, { transform: 'translate3d(0,0,0)' }],
        { duration: MOVE, delay: HOLD, easing: EASE, fill: 'both' }
      );
      for (var i = 1; i < n; i++) {
        var s = W / 2 - center(segs[i]);
        var delay = HOLD + (i - 1) * STAGGER;
        layers[i].animate(
          [{ transform: 'translate3d(' + s + 'px,0,0)' }, { transform: 'translate3d(0,0,0)' }],
          { duration: MOVE, delay: delay, easing: EASE, fill: 'both' }
        );
        layers[i].animate(
          [{ opacity: 0, filter: 'blur(6px)' }, { opacity: 1, filter: 'blur(0px)' }],
          { duration: 600, delay: delay, easing: 'ease-out', fill: 'both' }
        );
      }
      setTimeout(done, HOLD + (n - 2) * STAGGER + MOVE + 60);
    });
  }

  var probe = new Image();
  probe.crossOrigin = 'anonymous';
  probe.onload = function () {
    var segs = null;
    try { segs = analyze(probe); } catch (e) { segs = null; }
    play(pick(segs));
  };
  probe.onerror = function () { play([{ l: 0, r: 1 }]); };
  probe.src = img.currentSrc || img.src;
})();
